import React, { useState } from 'react';

const KEYMAP = {
  up: { key: 'ArrowUp', code: 'ArrowUp', keyCode: 38 },
  down: { key: 'ArrowDown', code: 'ArrowDown', keyCode: 40 },
  left: { key: 'ArrowLeft', code: 'ArrowLeft', keyCode: 37 },
  right: { key: 'ArrowRight', code: 'ArrowRight', keyCode: 39 },
  a: { key: ' ', code: 'Space', keyCode: 32 },
  b: { key: 'z', code: 'KeyZ', keyCode: 90 },
};

export const VirtualGamepad = ({ iframeRef }) => {
  const [isTouch] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches,
  );

  if (!isTouch) return null;

  const send = (dir, action) => {
    const map = KEYMAP[dir];
    if (!map || !iframeRef?.current) return;
    try {
      iframeRef.current.contentWindow.postMessage(
        { type: 'GAME_INPUT', key: map.key, code: map.code, keyCode: map.keyCode, action },
        '*',
      );
    } catch (e) {
      // srcDoc iframes are same-document; ignore cross-origin errors
    }
  };

  const holdProps = (dir) => ({
    onTouchStart: (e) => { e.preventDefault(); send(dir, 'down'); },
    onTouchEnd: (e) => { e.preventDefault(); send(dir, 'up'); },
    onMouseDown: () => send(dir, 'down'),
    onMouseUp: () => send(dir, 'up'),
    onMouseLeave: () => send(dir, 'up'),
  });

  const btnCls =
    'select-none rounded-lg bg-gray-800/90 border border-white/15 text-gray-100 active:bg-purple-600 flex items-center justify-center touch-none';

  return (
    <div data-testid="virtual-gamepad" className="w-full max-w-5xl flex items-end justify-between px-4 pb-2">
      {/* D-Pad */}
      <div className="grid grid-cols-3 grid-rows-3 gap-1 w-36 h-36">
        <div />
        <button type="button" aria-label="Up" data-testid="dpad-up" className={btnCls} {...holdProps('up')}>▲</button>
        <div />
        <button type="button" aria-label="Left" data-testid="dpad-left" className={btnCls} {...holdProps('left')}>◀</button>
        <div />
        <button type="button" aria-label="Right" data-testid="dpad-right" className={btnCls} {...holdProps('right')}>▶</button>
        <div />
        <button type="button" aria-label="Down" data-testid="dpad-down" className={btnCls} {...holdProps('down')}>▼</button>
        <div />
      </div>
      {/* Action buttons */}
      <div className="flex gap-3 items-end">
        <button type="button" data-testid="gamepad-btn-b" className={`${btnCls} w-14 h-14 rounded-full text-xs font-bold`} {...holdProps('b')}>B</button>
        <button type="button" data-testid="gamepad-btn-a" className={`${btnCls} w-16 h-16 rounded-full text-sm font-bold`} {...holdProps('a')}>A</button>
      </div>
    </div>
  );
};

export default VirtualGamepad;
